import { z } from 'zod';

const MIN_PASSWORD_LENGTH = 8;
const MIN_NAME_LENGTH = 2;

export const AuthSchema = z.object({
    email: z.string().email({ message: 'Invalid email address' }),
    password: z.string().min(MIN_PASSWORD_LENGTH, {
        message: 'Password must be at least 8 characters long',
    }),
});

export type AuthDto = z.infer<typeof AuthSchema>;

export const CheckAccountSchema = z.object({
    isAuthenticated: z.boolean(),
    isEmailConfirmed: z.boolean(),
});

export type CheckAccountDto = z.infer<typeof CheckAccountSchema>;

export const ResetPasswordSchema = z.object({
    email: z.string().email({ message: 'Invalid email address' }),
    redirectUrl: z.string({ message: 'Invalid redirect url' }),
});

export type ResetPasswordDto = z.infer<typeof ResetPasswordSchema>;
